<template>
  <v-card class="d-flex flex-column justify-space-between rounded-lg elevation-3" max-width="300">
    <v-img height="300" max-height="300" :src="salon.image"></v-img>
    <div class="salon-detail">
      <v-card-title class="primary--text text--darken-1 font-weight-bold">{{ salon.branch_name }}</v-card-title>
      <v-card-subtitle v-if="currentLocation.latitude && currentLocation.longitude" class="primary--text text--darken-1 font-weight-medium">
        {{ $t('label.kmAway', { distance: distance }) }}
      </v-card-subtitle>

      <v-card-text>
        <v-row align="center" class="mx-0 mb-3">
          <Rating :value="Number(salon.rate_number)" dense customStar />
        </v-row>

        <div class="salon-card__stylist-wrapper">
          <img
            v-for="stylist in stylists"
            :key="stylist.name"
            :src="stylist.photo || '/icons/profile_icon.svg'"
            class="salon-card__stylist-image"
            :class="{ 'default-image': !stylist.photo }"
            width="50px"
            height="50px"
          />
        </div>

        <span class="salon-address my-4 subtitle-1 d-flex flex-row align-start">
          <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
          <p>{{ salon.address }}</p>
        </span>
      </v-card-text>
    </div>

    <v-card-actions class="flex-column pb-4">
      <app-button
        v-if="isSGUser && currentUser"
        class="mx-auto py-5 px-8 font-weight-medium"
        :label="$t('label.makeAppointment')"
        gradient
        invert
        :to="{ name: $constants.ROUTE_NAME.APPOINTMENT_MAKE_APPOINTMENT, params: { storeBrandId: Number(brand), storeId: salon.id }, hash: '#store' }"
      />
      <v-divider v-if="isSGUser && currentUser" class="my-4 w-100" />
      <app-button class="mx-auto py-5 px-8 font-weight-medium" :label="$t('label.directMeThere')" gradient invert @click="mapRedirect" />
      <v-divider class="my-4 w-100" />
      <BusinessHoursDialog v-model="showBusinessHours" :storeId="salon.id" :businessHours="salon.business_hours" />
      <v-divider class="my-4 w-100" />
      <a class="d-block position-relative w-100" @click="$router.push({ name: $constants.ROUTE_NAME.SALON_REVIEW, params: { salonId: salon.id } })">
        <p class="secondary--text font-weight-bold text-center">
          {{ $t('label.reviews') }}
          <v-icon class="card-link-arrow">mdi-chevron-right</v-icon>
        </p>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import BusinessHoursDialog from '@/components/salons/BusinessHoursDialog.vue'
import Rating from '@/components/Rating.vue'
import { uiHelper } from '@/utils'

export default {
  components: {
    BusinessHoursDialog,
    Rating
  },

  props: {
    brand: { default: null, required: true },
    salon: { type: Object, required: true },
    currentLocation: { type: Object, required: false }
  },

  data() {
    return {
      showBusinessHours: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isSGUser']),
    ...mapState('auth', ['currentUser']),
    distance() {
      const origin = [this.currentLocation.latitude, this.currentLocation.longitude]
      return uiHelper.calculateDistance(origin, [this.salon.latitude, this.salon.longitude]).toFixed(2)
    },

    stylists() {
      let newArr = this.salon.stylists
      if (newArr.length > 5) newArr = newArr.splice(0, 5)
      return newArr
    }
  },
  methods: {
    mapRedirect() {
      if (this.salon.latitude !== 0 && this.salon.longitude !== 0) window.open(`https://www.google.com/maps/search/?api=1&query=${this.salon.latitude},${this.salon.longitude}`)
      else window.open(`https://www.google.com/maps/search/?api=1&query=${this.salon.address}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.salon-detail {
  height: 100%;
}
.salon-address {
  min-height: 5rem;
  line-height: 1.25rem;
}

.salon-card__stylist-wrapper {
  position: relative;
}

.salon-card__stylist-image {
  border-radius: 999vw;
  display: inline-block;

  @for $i from 2 through 5 {
    &:nth-child(#{$i}) {
      position: absolute;
      top: 0;
      left: 35px * ($i - 1);
      bottom: 0;
    }
  }
}

.card-link-arrow,
::v-deep .card-link-arrow {
  vertical-align: bottom;
  position: absolute;
  right: 0;
}
.default-image {
  background-color: white;
  border: 1px solid #808080;
  object-fit: none;
}
</style>
